var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 56L14 56.5L20 57C14.6687 61.7041 11.9502 68.7018 12.7076 75.7713L12.8811 77.3904C12.9446 77.9831 12.4802 78.5 11.8841 78.5H9.37133C7.02239 78.5 5.17906 76.4855 5.38704 74.1458L7 56Z",
    fill: "white",
    stroke: "#222831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.001 58.625C62.441 58.625 61.916 58.45 61.426 58.1C60.271 57.225 60.026 55.58 60.901 54.425C66.396 47.11 66.396 36.89 60.901 29.575C60.026 28.42 60.271 26.775 61.426 25.9C62.581 25.025 64.226 25.27 65.101 26.425C71.961 35.595 71.961 48.405 65.101 57.575C64.576 58.275 63.806 58.625 63.001 58.625Z",
    fill: "url(#paint0_linear_4945_18547)",
    stroke: "#222831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4053 67.375C68.8453 67.375 68.3203 67.2 67.8303 66.85C66.6753 65.975 66.4303 64.33 67.3053 63.175C76.6503 50.715 76.6503 33.285 67.3053 20.825C66.4303 19.67 66.6753 18.025 67.8303 17.15C68.9853 16.275 70.6303 16.52 71.5053 17.675C82.2503 31.99 82.2503 52.01 71.5053 66.325C71.0153 67.025 70.2103 67.375 69.4053 67.375Z",
    fill: "url(#paint1_linear_4945_18547)",
    stroke: "#222831"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29.179V54.8252C55 59.6304 52.8224 63.2342 48.9239 64.9663C47.3434 65.6648 45.5873 66 43.761 66C40.9512 66 37.9307 65.2457 34.84 63.7092L24.5844 58.5967C23.882 58.2615 23.0741 58.0659 22.2663 58.0659L19 58V26L22.2663 25.9384C23.0741 25.9384 23.882 25.7428 24.5844 25.4076L34.84 20.2951C39.9678 17.7528 44.9902 17.3058 48.9239 19.0379C52.8224 20.77 55 24.3739 55 29.179Z",
    fill: "white",
    stroke: "#222831"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26V58H16.8824C6.63294 58 1 54.2991 1 47.5652V36.4348C1 29.7009 6.63294 26 16.8824 26H19Z",
    fill: "url(#paint2_linear_4945_18547)",
    stroke: "#222831"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4945_18547",
    x1: 65.3105,
    y1: 25.374,
    x2: 65.3105,
    y2: 58.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4945_18547",
    x1: 73.1716,
    y1: 16.624,
    x2: 73.1716,
    y2: 67.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4945_18547",
    x1: 10,
    y1: 26,
    x2: 10,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.b0e95836e063f92e34c4154626fc7b65.svg";
export { ForwardRef as ReactComponent };